import { createFirstAdmin } from '@/scripts/createAdmin'
import { runAllTests } from '@/scripts/testFirebaseAuth'

/**
 * Inicializa o Firebase e cria o usuário administrador se necessário
 */
export const initializeFirebase = async () => {
  try {
    // Verificar ambiente de desenvolvimento
    if (import.meta.env.DEV) {
      console.log('🔥 Inicializando Firebase em ambiente de desenvolvimento')
      
      // Executar testes de diagnóstico
      console.log('🧪 Executando testes de diagnóstico...')
      const testResult = await runAllTests()
      
      // Se os testes passaram, não precisa criar o admin novamente
      if (testResult.success) {
        console.log('✅ Firebase Authentication está funcionando corretamente!')
        return
      }
      
      // Se falhou, tentar criar o usuário administrador
      console.log('🔄 Tentando criar usuário administrador...')
      await createFirstAdmin()
    }
  } catch (error) {
    console.error('❌ Erro ao inicializar Firebase:', error)
    console.error('📋 Verifique:')
    console.error('1. Se a autenticação Email/Password está habilitada no Firebase Console')
    console.error('2. Se as credenciais no firebase.ts estão corretas')
    console.error('3. Se o projeto Firebase está ativo')
    console.error('🔗 Link: https://console.firebase.google.com/project/escolar-ce5fb/authentication/providers')
  }
}